import { Snackbar, Alert } from "@mui/material";
import { useAlertProvider } from "../Providers/util/Alert";

export default function AlertToast() {
  const { open, handleClose, text, type } = useAlertProvider();
  return (
    <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
      <Alert severity={type} onClose={handleClose}>
        {text}
      </Alert>
    </Snackbar>
  );
}
